module.exports = __webpack_public_path__ + "static/media/Aloftmuralprogress2.1aa7b6e9.webp";